export default __webpack_public_path__ + "static/media/accounting_point_6.be9bc63d.png";